import { Configuration, AdminsApi as AdminsAPI } from "@/api/lab-base-api-client";
import { URLS } from "@/constants";
import TokenUtil from "@/utils/TokenUtil";

export default class AdminsApi extends AdminsAPI {
  private static _instance: AdminsApi;

  public static get instance(): AdminsApi {
    return this.createInstance();
  }

  public static createInstance(_token?: string) {
    if (_token) {
      const config = new Configuration({
        accessToken: _token,
        basePath: `${URLS.API_BASE_URL}${URLS.API_VERSION}`,
      });
      this._instance = new this(config);
    } else {
      if (this._instance == null) {
        const token = TokenUtil.getToken();
        if (this._instance == null && token) {
          const config = new Configuration({
            accessToken: token,
            basePath: `${URLS.API_BASE_URL}${URLS.API_VERSION}`,
          });
          this._instance = new this(config);
        } else {
          const config = new Configuration({
            basePath: `${URLS.API_BASE_URL}${URLS.API_VERSION}`,
          });
          this._instance = new this(config);
        }
      }
      if (!this._instance.configuration?.apiKey) {
        const token = TokenUtil.getToken();
        if (token) {
          const config = new Configuration({
            accessToken: token,
            basePath: `${URLS.API_BASE_URL}${URLS.API_VERSION}`,
          });
          this._instance = new this(config);
        }
      }
    }
    return this._instance;
  }
}
